import { render, staticRenderFns } from "./ParticaColumnContainer.vue?vue&type=template&id=0fe4b70c&"
import script from "./ParticaColumnContainer.vue?vue&type=script&lang=ts&"
export * from "./ParticaColumnContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports